module.exports = __webpack_public_path__ + "static/media/Diva Press.19ba54f8.png";